import React, { useState, useEffect } from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Img from 'gatsby-image';
import { Link } from '@reach/router';
import styled from 'styled-components';

import Wrapper from '../../elements/wrapper';
import SEO from '../../seo';

import TrashIcon from '../../../images/icons/trash.inline.svg';
import { media, TransitionMixin } from '../../helpers';

const StepTwoContainer = styled.section`
    .title-container {
        text-align: center;
        margin-bottom: 80px;

        h4 {
            margin-bottom: 25px;
        }

        h1 {
            font-size: 3rem;
            color: #000;
            font-family: neue-kabel, sans-serif;
            font-weight: 800;
            margin: 0 0 30px;
        }

        p {
            font-size: 1.1rem;
            font-weight: 400;
            max-width: 950px;
            margin: 0 auto;
            line-height: 1.5;
        }

        h4 {
            font-size: 1.1rem;
            font-style: italic;
            color: #000;
        }

        .progress-bar-container {
            display: flex;
            max-width: 550px;
            margin: 0 auto 40px;
            border-radius: 20px;
            border: 2px solid #000;
            .block {
                height: 20px;
                width: 300px;

                border-left: 2px solid #000;

                &:first-child {
                    border-top-left-radius: 20px;
                    border-bottom-left-radius: 20px;
                }
                &:last-child {
                    border-top-right-radius: 20px;
                    border-bottom-right-radius: 20px;
                }
                &.filled {
                    background-color: #f74d33;
                }
            }
        }
    }

    .branded-categories-container {
        display: flex;
        margin-bottom: 40px;
        justify-content: space-between;
        padding: 10px 20px 10px 0;
        ${media.large`max-width: 90vw;`}
        ${media.xl`max-width: 70vw; padding: 10px 0;`}

        @media (max-width: 1440px) {
            white-space: nowrap; /* [1] */
            overflow-x: auto; /* [2] */
            -webkit-overflow-scrolling: touch; /* [3] */
            -ms-overflow-style: -ms-autohiding-scrollbar; /* [4] */
            &::-webkit-scrollbar {
                display: none;
            }
        }

        .btn-container {
            flex: 0 0 12.66%;
            margin-right: 30px;
            ${media.large`margin-right: 0px;`}

            &:last-child {
                margin-right: 0px;
            }
            button {
                max-width: 170px;
                min-width: 170px;
                width: 100%;
                padding: 20px 10px;
                background-color: #fff;
                border: none;
                font-weight: bold;
                box-shadow: 5px 5px 12px rgba(0, 0, 0, 0.25);
                border-radius: 4px;
                ${TransitionMixin('.25s')};
                ${media.small`min-width: 0px;`}

                &:hover,
                &.active {
                    background-color: #f74d33;
                    color: #fff;
                }

                span {
                    margin-left: 5px;
                }
            }
        }
    }

    .branded-nav-container {
        margin-bottom: 40px;
        display: flex;
        justify-content: flex-end;
        align-items: center;
        ${media.medium`max-width: 90vw;`}
        ${media.xl`max-width: 70vw;`}

        .link-container {
            margin-right: 20px;
            ${media.medium`margin-right: 100px;`}
            flex: 1;
            a {
                color: #000;
                font-weight: bold;
                text-decoration: none;
            }
        }

        .btn-container {
            flex: 1;
            text-align: right;
            ${media.small`flex: 0 0 20%;`}
            ${media.large`flex: 0 0 12%;`}
            a {
                max-width: 170px;
                width: 100%;
                padding: 20px 0;
                background-color: #f74d33;
                color: #fff;
                text-decoration: none;
                border: none;
                font-weight: bold;
                border-radius: 4px;
                text-align: center;
                display: inline-block;
                font-family: neue-kabel, sans-serif;
                font-weight: 800;
            }
        }

        .total-count-container {
            margin-right: 20px;
            p {
                margin: 0;
            }
        }
    }

    .branded-products-grid {
        display: flex;
        flex-wrap: wrap;
        ${media.xl`max-width: 71vw;`}

        .item-container {
            margin-bottom: 20px;
            flex: 0 0 50%;
            ${media.small`flex: 0 0 33.33%;`}
            ${media.medium`flex: 0 0 20%;`}
            ${media.laptop`flex: 0 0 16.66%;`}

            &.selected {
                .inner-wrap {
                    border-color: #13a6ab;

                    .content-container {
                        background-color: #13a6ab;

                        h4 {
                            color: #fff;
                        }

                        p {
                            color: #fff;
                        }

                        button {
                            color: #fff;
                        }
                    }
                }
            }
            .inner-wrap {
                max-width: 90%;
                margin: 0 auto;
                border: 1px solid #efefef;
                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
            }

            .content-container {
                background-color: #e5e5e5;

                border-bottom-right-radius: 10px;
                border-bottom-left-radius: 10px;
                padding: 15px;
                ${media.laptop`padding: 20px;`}

                h4 {
                    font-size: 1rem;
                    color: #000;
                    margin: 0 0 5px;
                }

                p {
                    margin: 0 0 15px;
                    font-size: 0.8rem;
                    color: #13a6ab;
                    line-height: 1.2;
                }

                button {
                    font-size: 0.8rem;
                    color: #000;
                    background-color: transparent;
                    border: none;
                    text-decoration: underline;
                    padding: 0;

                    &:active,
                    &:focus {
                        outline: 0;
                    }

                    &:hover {
                        opacity: 0.7;
                    }
                }
            }
        }
    }
    .form-container {
        max-width: 590px;
        margin: 0 20px 20px;
        display: flex;
        flex-wrap: wrap;

        ${media.small`margin: 0 auto 40px;`}

        > * {
            flex: 1 1 100%;
        }

        h4 {
            margin: 0 0 10px;
        }

        textarea {
            min-height: 190px;
            background-color: #f2f0eb;
            padding-top: 10px;
            padding-left: 15px;
        }
    }
`;

// Form
const StepTwo = ({ brandedSettings, setBrandedSettings, brandedInit }) => {
    const data = useStaticQuery(graphql`
        query {
            branded_products: allWpBrandedProduct {
                edges {
                    node {
                        title
                        categories {
                            nodes {
                                slug
                                name
                            }
                        }
                        featuredImage {
                            node {
                                localFile {
                                    childImageSharp {
                                        fluid(maxWidth: 300) {
                                            ...GatsbyImageSharpFluid
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    `);

    const [currentFilter, setCurrentFilter] = useState('');
    const [currentFilteredProducts, setCurrentFilteredProducts] = useState([]);

    const categories = [
        {
            title: 'Neckties',
            slug: 'branded-neckties',
        },
        {
            title: 'Bowties',
            slug: 'branded-bow-ties',
        },
        {
            title: 'Pocket Squares',
            slug: 'branded-pocket-squares',
        },
        {
            title: 'Infinity Scarves',
            slug: 'branded-infinity-scarves',
        },
        {
            title: 'Chiffon Scarves',
            slug: 'branded-chiffon-scarves',
        },
        {
            title: 'Neck Gaiters',
            slug: 'branded-neck-gaiters',
        },
    ];

    const allBrandedProducts = data.branded_products.edges;
    function sortBrandedProducts(slug, title) {
        let filteredProducts = allBrandedProducts.filter((product) => {
            // console.log(product);
            let currentProductCategories =
                product.node.categories && product.node.categories.nodes;
            // console.log(currentProductCategories);
            let doesProductHaveCat = false;
            currentProductCategories.map((category) => {
                if (category.slug === slug) {
                    doesProductHaveCat = true;
                }
                return;
            });

            if (doesProductHaveCat) {
                return product;
            }
        });
        filteredProducts.sort(function (a, b) {
            if (a.node.title < b.node.title) {
                return -1;
            }
            if (a.node.title > b.node.title) {
                return 1;
            }
            return 0;
        });
        setCurrentFilteredProducts(filteredProducts);
        setCurrentFilter(title);
    }

    function handleCategoryChange(slug, title) {
        sortBrandedProducts(slug, title);
    }

    function handleStyleAdd(title, category, image) {
        if (brandedSettings.product_styles.length < 8) {
            let newItem = {
                title,
                category,
                image,
            };
            let newArray = brandedSettings.product_styles;
            newArray.push(newItem);

            setBrandedSettings({
                ...brandedSettings,
                product_styles: newArray,
            });
        }
    }

    function handleStyleRemove(title) {
        let newArray = brandedSettings.product_styles.filter(
            (style) => style.title !== title
        );

        setBrandedSettings({
            ...brandedSettings,
            product_styles: newArray,
        });
    }

    function updateDescription(e) {
        let newString = e.target.value;
        setBrandedSettings({
            ...brandedSettings,
            design_description: newString,
        });
    }

    useEffect(() => {
        brandedInit();
        handleCategoryChange('branded-neckties');
        setCurrentFilter('Neckties');
    }, []);
    return (
        <StepTwoContainer>
            <SEO title="Step 2 –– Branded" />
            <Wrapper className="title-container">
                <h4>Step 2</h4>
                <div className="progress-bar-container">
                    <div className="block filled"></div>
                    <div className="block filled"></div>
                    <div className="block"></div>
                    <div className="block"></div>
                </div>
                <h1>Products and patterns</h1>
                <p>
                    Select the patterns and designs you would like to customize.
                    Pick up to 8 styles for our designers to use as a starting
                    point
                </p>
            </Wrapper>
            <Wrapper className="form-container">
                <h4>Tell us what you have in mind:</h4>
                <textarea
                    value={brandedSettings.design_description}
                    onChange={(e) => updateDescription(e)}
                ></textarea>
            </Wrapper>
            <Wrapper className="branded-categories-container">
                {categories &&
                    categories.map((category, index) => {
                        const categoryCount = brandedSettings.product_styles.filter(
                            (style) => style.category === category.title
                        );
                        return (
                            <div className="btn-container" key={index}>
                                <button
                                    className={
                                        currentFilter === category.title
                                            ? 'active'
                                            : ''
                                    }
                                    value={category.slug}
                                    onClick={() =>
                                        handleCategoryChange(
                                            category.slug,
                                            category.title
                                        )
                                    }
                                >
                                    {category.title}
                                    {categoryCount.length > 0 && (
                                        <span>({categoryCount.length})</span>
                                    )}
                                </button>
                            </div>
                        );
                    })}
            </Wrapper>
            <Wrapper className="branded-nav-container">
                <div className="link-container">
                    <Link to="/branded/step-1">{'<'} Go back</Link>
                </div>
                <div className="total-count-container">
                    {brandedSettings.product_styles.length > 0 && (
                        <p>
                            Selected: {brandedSettings.product_styles.length}/8
                        </p>
                    )}
                </div>
                <div className="btn-container">
                    <Link to="/branded/step-3">Next Step</Link>
                </div>
            </Wrapper>
            <Wrapper className="branded-products-grid">
                {currentFilteredProducts &&
                    currentFilteredProducts.map((product) => {
                        // console.log(product);
                        const { title, featuredImage } = product.node || {};
                        const categoryName =
                            product.node.categories.nodes[0].name;

                        const doesProductHaveImage =
                            featuredImage != null &&
                            featuredImage.node &&
                            featuredImage.node.localFile &&
                            featuredImage.node.localFile.childImageSharp &&
                            featuredImage.node.localFile.childImageSharp.fluid;

                        let updatedCategory = categoryName.replace(
                            'Branded ',
                            ''
                        );
                        const isProductSelected =
                            brandedSettings.product_styles.filter(
                                (style) =>
                                    style.title === title &&
                                    style.category === updatedCategory
                            ).length > 0;

                        return (
                            <div
                                className={
                                    isProductSelected
                                        ? 'item-container selected'
                                        : 'item-container'
                                }
                            >
                                <div className="inner-wrap">
                                    <div className="image-container">
                                        {doesProductHaveImage && (
                                            <Img
                                                fluid={
                                                    featuredImage.node.localFile
                                                        .childImageSharp.fluid
                                                }
                                            />
                                        )}
                                    </div>
                                    <div className="content-container">
                                        <h4>{title}</h4>
                                        <p className="category">
                                            {categoryName}
                                        </p>
                                        <button
                                            onClick={() =>
                                                isProductSelected
                                                    ? handleStyleRemove(title)
                                                    : handleStyleAdd(
                                                          title,
                                                          currentFilter,
                                                          featuredImage.node
                                                              .localFile
                                                              .childImageSharp
                                                              .fluid
                                                      )
                                            }
                                        >
                                            {isProductSelected
                                                ? 'Remove'
                                                : 'Select'}
                                        </button>
                                    </div>
                                </div>
                            </div>
                        );
                    })}
            </Wrapper>
        </StepTwoContainer>
    );
};

export default StepTwo;
